import { gql } from '@apollo/client';

export const GET_ASK_REV_QUERY_HISTORY = gql`
	query GetAskRevQueryHistory($propertyId: String, $userId: String) {
		getAskRevQueryHistory(propertyId: $propertyId, userId: $userId) {
			property_id
			user_id
			query_text
			filters {
				field
				operator
				value
			}
			summary
			suggestion
		}
	}
`;

export const SAVE_ASK_REV_QUERY = gql`
	mutation SaveAskRevQuery($query: queryInput!) {
		saveAskRevQuery(query: $query) {
			success
			message
		}
	}
`;
